module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_nhnpixelcube_m.89e27f4724442114c7dddd66f46710be.png";